import React, { useEffect, useState } from "react";
import FriendForm from "./FriendForm.jsx";
import FriendList from "./FriendList.jsx";
import { t } from "../i18n";
import "./Friends.css";
import { api } from "../utils/api";
import { getSessionAuth } from "../utils/auth";
import { useConnections } from "../hooks/useConnections";

const Friends = () => {
  const [profilePic, setProfilePic] = useState("");
  const { token, userId } = getSessionAuth();
  const numericUserId = Number(userId);
  const { connections, isLoaded, loadConnections, setConnections } = useConnections(
    userId
  );

  useEffect(() => {
    async function fetchProfilePicture() {
      try {
        const result = await api.get(`/users/${userId}`);
        if (result.attributes?.picture) {
          setProfilePic(result.attributes.picture);
        } else {
          setProfilePic(require("../assets/Profile-Icon.png"));
        }
      } catch (error) {
        console.log("Error fetching profile picture", error);
        setProfilePic(require("../assets/Profile-Icon.png"));
      }
    }

    if (token && userId) {
      fetchProfilePicture();
    }
  }, [token, userId]);

  return (
    <div className="friends-page">
      <h2>{t("Friends")}</h2>
      <div className="profile-picture">
        <img src={profilePic} alt="Profile" className="profile-image" />
      </div>
      <FriendForm userid={numericUserId} loadFriends={loadConnections} />
      <FriendList
        userId={numericUserId}
        connections={connections}
        setConnections={setConnections}
        loadFriends={loadConnections}
        isLoaded={isLoaded}
      />
      {connections.length === 0 && isLoaded && (
        <p>{t("no_connections_found")}</p>
      )}
    </div>
  );
};

export default Friends;
